module.exports = __webpack_public_path__ + "static/media/Test_nn.29fe651a.jpg";